import { getLocale, getLanguageLong } from '@didi/gettext'
import getCountryConfig from '@/common/config/country-config'
import store from '@/store'
import { PLATFORM_NAME_MAP, COMMON_SHARE_CHANNELS } from '@/components/share/platformConfig'
import { util } from '@didi/soda-common'
import Api from '@/api'
import { get } from 'lodash-es'
const { env } = util

export function url2localProtocol (url = '') {
  url = url || ''
  const match = url.match(/^(http|https):(.*)/)
  if (match) {
    return window.location.protocol + match[2]
  } else {
    return url
  }
}

const inBrowser = typeof window !== 'undefined'
const UA = inBrowser && window.navigator.userAgent.toLowerCase()
const inNative = UA && (/FusionKit/i).test(UA)
export const inCustomerApp = inNative && (/soda.customer/i).test(UA)
const { country } = store.state

export function getScheme () {
  // return 'oneTravel' // IOS bug，独立端还未上线，先写死
  // return 'gsodacustomer'
  // 后补 2019-04-08更新   国际版独立端协议头gsodacustomer 嵌入端协议头globalOneTravel
  // 再后补 2019-11-29更新  新增99独立端与嵌入端
  let schemes = {
    'DiDi': {
      'Food': 'gsodacustomer',
      'Travel': 'globalOneTravel'
    },
    '99': {
      'Food': 'bsodacustomer',
      'Travel': 'taxis99OneTravel'
    }
  }
  let schemePath = `${country === 'BR' ? '99' : 'DiDi'}.${inCustomerApp ? 'Food' : 'Travel'}`

  return get(schemes, schemePath, 'gsodacustomer')
}

export function getAppType () {
  /*
  const US_OWN_IOS = 9;
  const US_OWN_ANDROID = 10;
  const GLOBAL_IOS = 11;
  const GLOBAL_ANDROID = 12;
  const BR_OWN_IOS = 13;
  const BR_OWN_ANDROID = 14;
  const BR_IOS = 15;
  const BR_ANDROID = 16;
  const GLOBAL_H5 = 17
  */
  const GLOBAL_H5 = 17
  let schemes = {
    'DiDi': {
      'Food': {
        'ios': 9,
        'android': 10
      },
      'Travel': {
        'ios': 11,
        'android': 12
      }
    },
    '99': {
      'Food': {
        'ios': 13,
        'android': 14
      },
      'Travel': {
        'ios': 15,
        'android': 16
      }
    }
  }
  let schemePath = `${country === 'BR' ? '99' : 'DiDi'}.${inCustomerApp ? 'Food' : 'Travel'}.${env.isIOS ? 'ios' : 'android'}`
  const appType = env.inNative ? get(schemes, schemePath, 9) : GLOBAL_H5
  return appType
}

window.getScheme = getScheme

export function getLocaleBrandText (textKey) {
  return getCountryConfig.brandText.brandText(country)[textKey][getLanguageLong()]
}

// 客服电话
export function getTelNum (countryCode) {
  return getCountryConfig.customContant.TELNUM(countryCode || country)
}

// 客服邮箱
export function getEmail (countryCode) {
  return getCountryConfig.customContant.EMAIL(countryCode || country)
}

/* getAmountTmpl 货币模板
* ** 注意：** 此方法仅返回拼接好的货币单位和金额顺序，以及class绑定，并不提供样式处理
* 需要在业务中自行处理，业务中style有使用scoped的，需要/deep/或者>>>符号 穿透覆盖
* @params splitData = {
    split: {},
    symbolClass: '',
    numberClass: ''
  }
* split结构必须为以下结构
* {
*   "symbol": "",
*  "number": "",
*  "position": 0, //0是货币在前，1是货币在后
*  "display": "MX$ 18.00",
*  "sign": "-"
* }
*/
export function getAmountTmpl ({split = {}, symbolClass = 'amount-symbol', numberClass = 'amount-number'}) {
  const symbol = `<span class="${symbolClass}">${split.symbol}</span>`
  const number = `<span class="${numberClass}">${split.number}</span>`
  return split.position ? (number + symbol) : (symbol + number)
}

export function debounce (func, wait, immediate) {
  let timeout
  let result

  const later = function (context, args) {
    timeout = null
    if (args) {
      result = func.apply(context, args)
    }
  }

  const debounced = function (...args) {
    if (timeout) {
      clearTimeout(timeout)
    }
    if (immediate) {
      const callNow = !timeout
      timeout = setTimeout(later, wait)
      if (callNow) {
        result = func.apply(this, args)
      }
    } else {
      timeout = setTimeout(() => {
        later(this, args)
      }, wait)
    }

    return result
  }

  debounced.cancel = function () {
    clearTimeout(timeout)
    timeout = null
  }

  return debounced
}

// 获取各渠道需要配置的字段
function getShareField (channel) {
  let defaultFiled = ['title', 'url', 'content', 'icon']
  let channelShareField = {
    facebook: ['url', 'icon', 'content', 'title']
  }
  return channelShareField[channel] || defaultFiled
}

// 分享配置
export async function getShareConfig (share, shareUrl, channelOrder) {
  let commonConfig = share.default || {}
  let res = {
    common: {
      title: commonConfig.title,
      url: shareUrl,
      content: commonConfig.content,
      icon: commonConfig.icon
    }
  }

  // 配置渠道
  if (channelOrder) {
    // 存在顺序则按照顺序处理以便前端按顺序展示
    channelOrder.forEach(channel => {
      let channelFiled = getShareField(channel)
      let allFiled = {
        title: share[channel] ? share[channel].title : commonConfig.title,
        url: shareUrl,
        content: share[channel] ? share[channel].content : commonConfig.content,
        icon: share[channel] ? share[channel].icon : commonConfig.icon
      }
      // 渠道级别的字段可以使用getShareField方法
      // 在channelShareField中配置即可
      res[channel] = res[channel] || {}
      channelFiled.forEach(filed => {
        res[channel][filed] = allFiled[filed]
      })
    })
  } else {
    Object.entries(share).forEach(entry => {
      let [key, value] = entry
      if (PLATFORM_NAME_MAP[key]) {
        res[key] = {
          title: value.title,
          url: `${shareUrl}`,
          content: value.content,
          icon: value.icon
        }
      }
    })
  }

  // 公共渠道 (sms, email, systemEntrance)
  COMMON_SHARE_CHANNELS.forEach(channel => {
    res[channel] = {
      title: commonConfig.title,
      url: shareUrl,
      content: commonConfig.content,
      icon: env.isIOS ? commonConfig.icon : ''
    }
  })
  return res
}

// 生成短链
export async function getShortLink (url) {
  let globalParams = {}
  try {
    // 只在独立端内可以通过bridge获取country
    let res = await SodaBridge('getGlobalParams', 'badcase') || {}
    globalParams = res.data
  } catch (e) {}
  let shortLinkKey = country === 'BR' ? 'short_url_99' : 'short_url'
  let shortLinkRes = await Api.getShortLink({url, ...globalParams})
  return shortLinkRes.data[shortLinkKey]
}

export function getUrlLanguage () {
  let paths = window.location.pathname.split('/')
  let isI18nDomain = paths.length > 1 && /^\w{2}-\w{2}$/.test(paths[1])
  return isI18nDomain ? paths[1] : 'es-MX'
}

/**
 * businessType string 内部业务类型
 * 1:r, 2:c, 3:b, 4:bd
 **/
export function getActivityType (type) {
  switch (type) {
    case 1: return 'DC'
    case 3: return 'BC'
    case 2: return 'CC'
    default: return 'CC'
  }
}

/**
 * 检查当前版本是否为旧版本，版本号需符合 x.x.x 格式
 * @param {*} curVersion 当前版本号
 * @param {*} baseVersion 基准版本号
 */
export function checkIsOldVersion (curVersion, baseVersion) {
  const curVersionArr = curVersion && curVersion.split('.')
  const baseVersionArr = baseVersion && baseVersion.split('.')

  const minL = Math.min(curVersionArr && curVersionArr.length, baseVersionArr && baseVersionArr.length)
  let pos = 0
  let diff = 0
  while (pos < minL) {
    diff = parseInt(curVersionArr[pos]) - parseInt(baseVersionArr[pos])
    if (diff !== 0) {
      break
    }
    pos++
  }

  return diff < 0
}

/**
 * 计算字符的物理长度
 * @param {*} text 所要计算的字符串
 * @param {*} font 字体样式
 */
export function getTextWidth (text, font) {
  const canvas = document.createElement('canvas') // 新增 canvas 元素
  const context = canvas.getContext('2d') // 返回 canvas 的上下文绘图环境
  context.font = font || getComputedStyle(document.body).font
  const metrics = context.measureText(text) // 测量字符串的宽
  return Math.ceil(metrics.width) // 向上取整
}

// 项目里没用到 可以废弃
export function dateFormat (dateStr) {
  dateStr = dateStr.split(' ')[0]
  const locale = getLocale()
  let dateStrRes = ''
  if (locale === 'zh-CN') {
    dateStrRes = dateStr
  } else if (locale === 'en-US') {
    let dateArr = dateStr.split('-')
    let tempItem = dateArr[0]
    dateArr[0] = dateArr[1]
    dateArr[1] = dateArr[2]
    dateArr[2] = tempItem
    dateStrRes = dateArr.join('-')
  } else if (locale === 'es-MX') {
    let dateArr = dateStr.split('-')
    let tempItem = dateArr[0]
    dateArr[0] = dateArr[2]
    dateArr[2] = tempItem
    dateStrRes = dateArr.join('-')
  } else if (locale === 'pt-BR') {
    let dateArr = dateStr.split('-')
    let tempItem = dateArr[0]
    dateArr[0] = dateArr[2]
    dateArr[2] = tempItem
    dateStrRes = dateArr.join('-')
  }
  return dateStrRes
}

/**
 * 解析url参数
 * url 参数 不输入默认解析当前页面的URL参数
 * @example ?id=12345&a=b
 * @return Object {id:12345,a:b}
 */
export function urlParse (url) {
  const search = url || window.location.search
  const reg = /[?&][^?&]+=[^?&]+/g
  const arr = search.match(reg)
  let obj = {}
  if (arr) {
    arr.forEach(item => {
      let tempArr = item.substring(1).split('=')
      let key = decodeURIComponent(tempArr[0])
      let val = decodeURIComponent(tempArr[1])
      obj[key] = val
    })
  }
  return obj
}

export function getCouponBackground () {
  return getCountryConfig.couponBg.COUPON_BG_DEFAULT(country)
}

export function getIntNumFromAmount (amount = '') {
  if (amount) {
    let amountStr = amount.toString()
    let splitSigns = [',', '.']
    // 判断length大于3，且倒数第三位是分割符则进行抹零操作
    if (amountStr.length > 3 && splitSigns.includes(amountStr.slice(-3, -2))) {
      return amountStr.slice(0, -3)
    } else {
      return amountStr
    }
  } else {
    return ''
  }
}
export function formatCoupon (couponList) {
  return couponList.map(coupon => {
    return {
      name: coupon.batch_name, // 券名称
      couponId: coupon.couponid, // 券Id
      couponType: +coupon.coupon_type, // 券类型 3:抵扣券 100:折扣券
      couponAmount: coupon.coupon_amount, // 抵扣券最高抵扣金额
      couponAmountSplit: coupon.rl_coupon_amount_split, // 券面额及货币符号结构，日本改造后启用 接口文档：http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=279139099
      expireTimeDisplay: coupon.rl_expire_time_display, // 过期时间，后端返回的可直接展示的时间字符串
      discount: coupon.discount, // 折扣券-折扣数
      remark: coupon.remark, // 券说明
      rlCustomLogo: coupon.rl_custom_logo, // 商家券logo
      // currency: currencyType['' + coupon.currency], // 已废弃，国家码，日本改造后已废弃
      availableStatus: +coupon.status === 2 && +coupon.rl_expired === 0 ? 1 : 2, // status 券状态 见wiki: http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=104837020; rl_expired 代表券是否过期 1:已过期 0:未过期
      isNew: coupon.isNew, // 新版优惠券新增 是否为新手券 0:非新手券 1:新手券
      minCost: coupon.minCost || 0, // 新版优惠券新增 最小使用金额
      minCostSplit: coupon.minCostSplit || {}, // 新版优惠券新增 最小使用金额
      expireTime: coupon.expireTimeFmt, // 新版优惠券新增，过期时间。已精确为当地时间
      maxAmount: coupon.max_amount || 0, // 新版优惠券新增，折扣券展示用，折扣券最高可抵扣金额
      maxAmountSplit: coupon.maxAmountSplit || {}, // 新版优惠券新增，折扣券展示用，折扣券最高可抵扣金额
      useRuleCity: coupon.useRuleCity || [], // 新版优惠券新增，城市维度使用限制
      useRuleWeekDay: coupon.useRuleWeekDay || [], // 新版优惠券新增，星期维度使用限制
      useRuleTimeRange: coupon.useRuleTimeRange || [], // 新版优惠券新增，券使用时间限制。精确到时分
      useRuleDate: coupon.useRuleDate || [], // 新版优惠券新增，券使用日期限制
      payTypeList: coupon.payTypeList || [], // 新版优惠券新增，支付方式列表
      costType: coupon.costType || 0, // 新版优惠券新增，抵扣类型
      shopNameList: coupon.shopNameList || [] // 新版优惠券新增，可使用店铺列表
    }
  })
}

/**
 * 拼接货币展示模板
 * 根据后端返回的货币结构split，拼接输出html模板
 * @param {*} split 货币展示结构，包括金额 number，货币符号 symbol，符号展示位置 position
 * @param {*} classSymbol 货币符号span class名
 * @param {*} classNumber 金额span class名
 * @return <span class="symbol">$</span><span class="number">100</span>
 */
export function amountTemplate (data) {
  let resTemplate = ''
  if (data) {
    const { split, clsSymbol, clsNumber } = data
    if (split) {
      const { number, symbol, position } = split // position 货币符号位置 0 货币符号在前 1 货币符号在后
      const symbolFirst = `<span class="${clsSymbol}">${symbol}</span><span class="${clsNumber}">${number}</span>`
      const numberFirst = `<span class="${clsNumber}">${number}</span><span class="${clsSymbol}">${symbol}</span>`
      resTemplate = +position === 0 ? symbolFirst : numberFirst
    }
  }
  return resTemplate
}

// 获取中间页链接
export function getDeepLink () {
  return getCountryConfig.deepLinkUrl.DEEPLINKURL(country)
}

// 操作系统类型
// 0：default
// 1：ios
// 2：android
// 9 ：windows
// 10 ：macOs
export const getDevice = () => {
  let agent = navigator.userAgent.toLowerCase()
  let result = {
    device: (function () {
      if (/windows/.test(agent)) {
        return 9
      } else if (/iphone|ipod|ipad/.test(agent) && /mobile/.test(agent)) {
        return 1
      } else if (/android/.test(agent) && /mobile/.test(agent)) {
        return 2
      } else if (/mac/.test(agent)) {
        return 10
      } else {
        return 0
      }
    })()
  }
  return result.device
}

/** @desc js秒转时分秒 */
export const secondToDate = (result) => {
  let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600)
  let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60))
  let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60))
  return (h + ':' + m + ':' + s)
}

// 获取url上的参数
export function getUrlParams () {
  let paramsString = window.location.search.slice(1)
  var items = paramsString.split('&')
  var result = {}
  items.forEach(item => {
    let temp = item.split('=')
    result[temp[0]] = temp[1]
  })
  return result
}

const entities = {
  '&lt;': '<',
  '&gt;': '>',
  '&#x2F;': '/'
}

export function decodeHtml (text) {
  const name = Object.keys(entities)
  let newText = text
  for (let key of name) {
    // replaceAll 部分手机兼容
    newText = newText.replaceAllCopy(key, entities[key])
  }
  return newText
};

String.prototype.replaceAllCopy = function (search, replace) { // eslint-disable-line
  const searchType = Object.prototype.toString.call(search)
  let newStr = this
  // 如果是正则表达式
  if (searchType === '[object RegExp]') {
    if (search.flags.indexOf('g') === -1) {
      throw new TypeError('String.prototype.replaceAll called with a non-global RegExp argument')
    } return newStr.replace(search, replace)
  }
  // 如果是引用类型，就转成字符串
  search += ''
  while (newStr.indexOf(search) > -1) {
    newStr = newStr.replace(search, replace)
  }
  return newStr
}

export const DEFAULT_IMG_BASE64 = 'data:image/png;base64,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data:image/png;base64,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'
